import store from '@/store';
import { fetchData } from './classroom.api.helper';

const classroomapi = process.env.VUE_APP_CLASSROOM_INTEGRATION_URL;
const nexusapi = process.env.VUE_APP_NEXUS_INTEGRATION_URL;
const classroomChatApi = process.env.VUE_APP_ENDPOINT_URL;
const nexusChatApi = process.env.VUE_APP_NEXUS_CHAT_URL;

const whichApi = () => {
  const isNexusUser = store && store.state && store.state.settings && store.state.settings.isNexusUser;
  const api = isNexusUser ? nexusapi : classroomapi;
  return api;
};

const whichChatApi = () => {
  const isNexusUser = store && store.state && store.state.settings && store.state.settings.isNexusUser;
  const api = isNexusUser ? nexusChatApi : classroomChatApi;
  return api;
};

const getClassroomDetailsByCode = param => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/classes/byCode/${param}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getClassroomById = id => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${store.state.users.loggedInUserProfile.user.id}/classes/${id}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const joinClassroomByCode = (param, body) => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${param}/join`;
  fetchData(endpointURL, 'post', body).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const updateUserExpressions = (param, body) => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${param}`;
  fetchData(endpointURL, 'patch', body).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getStudentProfile = params => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${params.studentId}/me?token=${params.studentToken}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getClassroomsByStudent = params => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${params.studentId}/classes`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getOpenAssignmentsByClassId = params => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/v2/students/${user.id}/classes/${params.classId}/assignments/open?page=${params.index ? params.index : 0}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getOpenAssignments = () => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/v2/students/${user.id}/assignments/open`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getClosedAssignmentsByClassId = params => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/v2/students/${user.id}/classes/${params.classId}/assignments/closed?page=${params.index ? params.index : 0}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const leaveClassroomByStudent = params => new Promise(((resolve, reject) => {
  const api = whichApi();
  const endpointURL = `${api}client/students/${store.state.users.loggedInUserProfile.user.id}/leave/${params.classId}`;
  const body = {
    token: store.state.users.loggedInUserProfile.user.token,
  };

  fetchData(endpointURL, 'delete', body).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getStudent = () => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/students/${user.id}/me?token=${user.token}`;

  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getStudentSettingsByClass = classId => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/students/${user.id}/settings/${classId}`;
  const body = {
    token: user.token,
  };
  fetchData(endpointURL, 'get', body).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const updateStudentSettings = body => new Promise(((resolve, reject) => {
  const api = whichApi();
  const user = store.state.users.loggedInUserProfile.user;
  const endpointURL = `${api}client/students/${user.id}/settings/${body.classId}`;
  body.token = user.token;
  fetchData(endpointURL, 'patch', body).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getUnseenMessagesForClass = (chatRoomId, token) => new Promise((resolve, reject) => {
  const chatapiURL = whichChatApi();
  const endpointURL = `${chatapiURL}/chat/conversations/${chatRoomId}/unseenMessages?whichApiKey=${token}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getAssignmentByDktId = dktAssignmentId => new Promise((resolve, reject) => {
  const chatapiURL = whichApi();
  const endpointURL = `${chatapiURL}client/v2/assignmentsByDktId/${dktAssignmentId}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result);
    }).catch((error) => {
      reject(error);
    });
});

export default {
  getClassroomDetailsByCode,
  getClassroomById,
  joinClassroomByCode,
  updateUserExpressions,
  getStudentProfile,
  getClassroomsByStudent,
  getOpenAssignmentsByClassId,
  getClosedAssignmentsByClassId,
  leaveClassroomByStudent,
  getStudent,
  getStudentSettingsByClass,
  updateStudentSettings,
  getOpenAssignments,
  getUnseenMessagesForClass,
  getAssignmentByDktId,
};
